/**
 * Marketing highlights shown alongside the branded split-screen layout on
 * untrusted (signed-out) screens. Kept in one place so the messaging stays
 * consistent across login, registration, and account-recovery flows.
 */
export const BRAND_HIGHLIGHTS = [
    'Ship features safely with gradual rollouts',
    'Instant kill switches — no deploys needed',
    'Target specific users and segments',
]
